var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href && _vm.href.length > 0)?_c('a',{class:_vm.badgeClass,attrs:{"href":_vm.href,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_vm._v("\n  PDF\n  "),_c('font-awesome-icon',{attrs:{"icon":['fal', 'paperclip']}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }